<template>
    <!-- eslint-disable vue/no-v-html -->
    <div>
        <div v-if="data.thermal_bag_info" class="thermal-bag-info">
            {{ data.thermal_bag_info }}
        </div>
        <div v-if="data.thermal_bag_items.length == 0" class="cart-crosssell">
            <div
                id="lbx-crosssell-cart"
                :data-product-sku="data.sku"
                class="cart-crosssell__items"
            ></div>
        </div>

        <!-- eslint-disable vue/no-v-html -->
        <div
            v-if="data.thermal_bag_items && data.thermal_bag_items.length"
            class="cart-thermal-bag"
            type
        >
            <h3 class="cart-thermal-bag__title">
                Do Twojego zamówienia możesz dodać
            </h3>
            <div ref="thermal_bag_items" class="cart-thermal-bag__items">
                <div
                    v-for="(item, index) in data.thermal_bag_items"
                    :key="index"
                    class="cart-thermal-bag__item-wrapper"
                    :data-gtm-product-id="`${type}-popup-${item.gtm.id}`"
                    gtm-element="product-item"
                >
                    <a
                        :href="item.url"
                        class="cart-thermal-bag__item"
                        tabindex="0"
                    >
                        <div v-if="item.img" class="cart-thermal-bag__item-img">
                            <img
                                :src="item.img"
                                :alt="item.name ? item.name : ''"
                            />
                        </div>
                        <p v-if="item.name" class="cart-thermal-bag__item-name">
                            {{ item.name }}
                        </p>
                    </a>

                    <form
                        action="/ajaxcart/index/add"
                        class="product_addtocart_form"
                        enctype="multipart/form-data"
                    >
                        <input name="form_key" type="hidden" :value="formKey" />
                        <input
                            id="product_id"
                            type="hidden"
                            name="product"
                            :value="item.id"
                        />
                        <input
                            id="listCategory"
                            type="hidden"
                            name="listCategory"
                            :value="item.gtm.list"
                        />

                        <button
                            type="button"
                            class="product-item__btn"
                            data-vue-init="add-to-cart"
                            @click="addToCart"
                        >
                            {{ item.price }} zł
                            <span class="button_icon">
                                <CartIcon
                                    class="icon icon-cart icon--inline"
                                    width="28"
                                    height="24"
                                    view-box="0 0 24 28"
                                />
                            </span>
                        </button>
                    </form>

                    <div class="tooltip-max-price-info">
                        <p>
                            Podana cena jest ceną maksymalną<br />
                            <span
                                data-tooltip-cms="product_shipment_info"
                                data-toggle="tooltip"
                                data-html="true"
                                data-placement="bottom"
                                data-original-title='<div class="cms-block"><div·class="cms-block__content"><p>Proste zasady - realizujesz zam&amp;oacute;wienie i kupujesz zarezerwowane produkty w wybranej aptece. Już ponad 2600 aptek w Apteline.pl!</p>
                                    <ul>
                                    <li>podana przy produktach nierefundowanych cena jest ceną maksymalną - cena sprzedaży ustalana jest przez aptekę</li>
                                    <li>miejsce odbioru: wybrana przez Ciebie apteka</li>
                                    <li>dostawa: zawsze GRATIS</li>
                                    <li>czas dostawy: maksymalnie 24 godziny (wyjątkiem mogą być weekendy i święta)</li>
                                    <li>większość zam&amp;oacute;wień złożonych przed południem można odebrać tego samego dnia</li>
                                    <li>wiadomość sms ze statusem zam&amp;oacute;wienia</li>
                                    <li>płatność w aptece przy odbiorze</li>
                                    <li>bezpieczeństwo: leki z hurtowni prosto do apteki</li>
                                    </ul></div></div>'
                            >
                                <span style="text-decoration: underline">
                                    Dowiedz się więcej
                                </span>
                            </span>
                        </p>
                    </div>
                </div>
            </div>

            <div
                v-show="
                    (isMobile && data.thermal_bag_items.length > 1) ||
                    (isDesktop && data.thermal_bag_items.length > 3)
                "
                ref="arrows"
                class="cart-thermal-bag__switcher"
            >
                <button
                    ref="arrowLeft"
                    aria-label="Poprzedni produkt"
                    title="Poprzedni produkt"
                    class="btn btn--clear"
                >
                    <span
                        data-icon="arrow-left-green"
                        style="width: 22px; height: 22px"
                    />
                </button>

                <button
                    ref="arrowRight"
                    aria-label="Kolejny produkt"
                    title="Kolejny produkt"
                    class="btn btn--clear"
                >
                    <span
                        data-icon="arrow-right-green"
                        style="width: 22px; height: 22px"
                    />
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import resizeObserver from '../utils/resizeObserver.js'
import handleSliderArrows from '@js/utils/handleSliderArrows.js'
import icons from '@js/app/icons.js'
import CartIcon from '@icons/cart2.svg'

export default {
    components: {
        CartIcon
    },
    mixins: [resizeObserver],
    props: {
        data: {
            type: Object,
            default: () => {}
        },
        // type of products (crosssell or upsell)
        type: {
            type: String,
            default: 'crosssell'
        },
        priceTooltip: {
            type: String,
            default: ''
        },
        formKey: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            slider: null
        }
    },
    mounted() {
        this.$nextTick(() => {
            if (this?.data.thermal_bag_items?.length > 1) {
                this.initSlider()
                icons(this.$refs.arrows)
            }

            if (window?.GoogleAnalyticsUniversal) {
                let impressions = []
                this.data.thermal_bag_items.forEach((item) => {
                    impressions.push(item.gtm)
                    window.staticImpressions[
                        `${this.type}-popup-${item.gtm.id}`
                    ] = item.gtm
                })
                window.GoogleAnalyticsUniversal.prototype.pushImpressions(
                    impressions
                )
                window.GoogleAnalyticsUniversal.prototype.listenImpressionClick(
                    this.$refs.thermal_bag_items
                )
            }
        })
    },
    methods: {
        initSlider() {
            this.slider = new window.Glider(this.$refs.thermal_bag_items, {
                slidesToShow: 1,
                slidesToScroll: 1,
                scrollLock: true,
                rewind: true,
                draggable: true,
                responsive: [
                    {
                        breakpoint: 419,
                        settings: {
                            slidesToShow: 1
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3
                        }
                    }
                ],
                arrows: {
                    prev: this.$refs.arrowLeft,
                    next: this.$refs.arrowRight
                }
            })
            handleSliderArrows(this.slider)
        },
        destroyCrossSellSlider() {
            if (this.slider) {
                this.slider.destroy()
            }
        },
        addToCart(event) {
            window.$apteline.cart.AddToCart(event.currentTarget)
        }
    }
}
</script>

<style lang="scss">
.t-general .cart-crosssell {
    &__items {
        width: inherit;
        max-width: inherit;
        padding-bottom: 20px;
        width: 90%;
        margin: 0 auto;
    }
}

.t-general .cart-thermal-bag {
    background-color: $gray-light;
    padding-top: 10px;
    width: 100%;
    max-width: 100%;
    position: relative;
    border-radius: 8px;

    .tooltip-max-price-info {
        margin: 10px 0 0 0;
        padding: 0 5px 0 0;

        p {
            font-size: 9px;
        }
    }

    .product-item__btn {
        font-size: 14px;
        font-weight: $font-weight-bold;
        padding: 0;
        min-height: 36px;
        margin-top: 8px;

        .button_icon {
            .icon {
                margin-right: 0;
            }
        }
    }

    &__title {
        font-size: 17px;
        margin-bottom: 0;
        font-weight: $font-weight-bold;
        text-align: center;
        text-transform: none;

        @media #{$media-to-sm} {
            line-height: 20px;
            font-size: 13px;
        }
    }

    &__items {
        max-width: 500px;
        padding: 0 0 20px 0;
        width: 500px !important;
        margin: 0 auto;

        @media #{$media-xs} {
            width: 200px;
            max-width: 220px;
        }
    }

    &__item {
        align-self: center;
        display: flex;
        flex-direction: column;
        text-align: center;

        &-price {
            .price {
                color: $blue-dianne;
                font-weight: $font-weight-bold;
            }
        }

        &-price_info {
            border: solid 1px red;
        }

        &-wrapper {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            max-width: 145px;
            min-width: 145px;
            align-self: center;
            background: #fff;
            border-radius: 10px;
            border: 1px solid #cee7d8;
            margin: 10px 10px;
            padding: 10px;
            text-align: center;

            @media #{$media-xs} {
                max-width: 200px;
            }
        }

        &-img {
            position: relative;
            margin-bottom: 15px;

            img {
                height: 100px;
                max-height: 100px;
                margin: 0 auto;
            }
        }

        &-name {
            margin: 0;
            font-size: 13px;
            color: #000;
            line-height: 1.4;
            font-weight: 600;
            overflow: hidden;
            height: 57px;
        }
    }

    &__switcher {
        position: absolute;
        top: 50%;
        left: 0;
        right: 0;
        width: 100%;
        display: flex;
        justify-content: space-between;
        padding: 0 5px;

        button {
            visibility: hidden;
            border: solid 1px #007f32;
            height: 40px;
            width: 52px;
            border-radius: 20px;
            top: 44%;
            background-color: white;
        }
    }
}

.thermal-bag-info {
    background-color: #ebf5fc;
    background-image: url("data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.0008 16.5C12.1426 16.5 12.2612 16.4521 12.3567 16.3562C12.4522 16.2604 12.5 16.1417 12.5 16V11.5C12.5 11.3583 12.452 11.2396 12.356 11.1438C12.26 11.0479 12.1411 11 11.9993 11C11.8574 11 11.7388 11.0479 11.6433 11.1438C11.5478 11.2396 11.5 11.3583 11.5 11.5V16C11.5 16.1417 11.548 16.2604 11.644 16.3562C11.74 16.4521 11.8589 16.5 12.0008 16.5ZM12 9.577C12.1743 9.577 12.3205 9.518 12.4385 9.4C12.5565 9.282 12.6155 9.13583 12.6155 8.9615C12.6155 8.78717 12.5565 8.641 12.4385 8.523C12.3205 8.40517 12.1743 8.34625 12 8.34625C11.8257 8.34625 11.6795 8.40517 11.5615 8.523C11.4435 8.641 11.3845 8.78717 11.3845 8.9615C11.3845 9.13583 11.4435 9.282 11.5615 9.4C11.6795 9.518 11.8257 9.577 12 9.577ZM12.0033 21C10.7587 21 9.58867 20.7638 8.493 20.2915C7.3975 19.8192 6.4445 19.1782 5.634 18.3685C4.8235 17.5588 4.18192 16.6067 3.70925 15.512C3.23642 14.4175 3 13.2479 3 12.0033C3 10.7587 3.23617 9.58867 3.7085 8.493C4.18083 7.3975 4.82183 6.4445 5.6315 5.634C6.44117 4.8235 7.39333 4.18192 8.488 3.70925C9.5825 3.23642 10.7521 3 11.9967 3C13.2413 3 14.4113 3.23617 15.507 3.7085C16.6025 4.18083 17.5555 4.82183 18.366 5.6315C19.1765 6.44117 19.8181 7.39333 20.2908 8.488C20.7636 9.5825 21 10.7521 21 11.9967C21 13.2413 20.7638 14.4113 20.2915 15.507C19.8192 16.6025 19.1782 17.5555 18.3685 18.366C17.5588 19.1765 16.6067 19.8181 15.512 20.2908C14.4175 20.7636 13.2479 21 12.0033 21ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z' fill='%23036EB7'/%3E%3C/svg%3E%0A");
    background-repeat: no-repeat;
    background-position-x: 26px;
    background-position-y: center;
    border-radius: 8px;
    color: #2f3146;
    padding: 16px 16px 16px 56px;
    margin: 30px 0 32px 0;
    text-align: left;
    font-size: 16px;
    line-height: 28px;

    @media #{$media-xs} {
        font-size: 14px;
        line-height: 22px;
        margin-top: 10px;
        background-position-x: 17px;
    }
}
</style>
